<template>
    <div id="ajoneuvoverolaskuri">
        <Ajoneuvoverolaskuri v-if="mainLoaded" v-bind:cameFromLKPLaskuri="cameFromLKPLaskuri"/>
    </div>
</template>

<script lang="ts">
    import { Component, Vue, Prop } from "vue-property-decorator"
    import Ajoneuvoverolaskuri from "@/components/Ajoneuvoverolaskuri.vue"
    import ListsModel from "../models/listsModel"

    @Component({
        components: {
            Ajoneuvoverolaskuri
        }
    })
    export default class AjoneuvoverolaskuriPage extends Vue {
        @Prop(String) cameFromLKPLaskuri!: string

        get mainLoaded(): boolean {
            return this.$store.getters.mainLoaded
        }
    }
</script>
